import { render, staticRenderFns } from "./assign-vendor-list.vue?vue&type=template&id=c7677914&"
import script from "./assign-vendor-list.vue?vue&type=script&lang=js&"
export * from "./assign-vendor-list.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports